<template>
	<div id="payment">
    <h4>如需要开发票，请与物业前台联系</h4>
		<p class="houseName">缴费房产：<span>{{this.houseName}}</span></p>
		<div class="paymentDetail">
			<ul>
        <li class="itemName clear" v-for="(item,index) in items" :key="index">
          <p class="itemName clear">
            <span class="float-l">费项：</span>
            <span class="float-r span2">{{item.feename}}</span>
          </p>
          <p class="amount clear">
            <span class="float-l">金额：</span>
            <span class="float-r span1">{{item.uncollected_amount.toFixed(2)}}元</span>
          </p>
          <p class="receiptEnddate clear">
            <span class="float-l">缴费截止日期：</span>
            <span class="float-r span2">{{item.receipt_enddate}}</span>
          </p>
          <p class="feedate clear">
            <span class="float-l">计费日期：</span>
            <span class="float-r span2">{{item.cost_startdate}}至{{item.cost_enddate}}</span>
          </p>
        </li>
			</ul>
      <div class="footer-li">
        <p class="clear">
          <span class="spa1 float-l">合计金额：</span>
          <span class="spa2 float-r">{{parseFloat(this.rental).toFixed(2)}}元</span>
        </p>
        <p class="clear">
          <span class="spa1 float-l">优惠金额：</span>
          <span class="spa2 spa4 float-r">-{{parseFloat(this.discount_amount).toFixed(2)}}元</span>
        </p>
        <p class="clear p3">
          <span class="spa3 float-l">实付金额：</span>
          <span class="spa5 float-r">{{parseFloat(this.payable_amount).toFixed(2)}}元</span>
        </p>
      </div>
		</div>
    <div class="bottom-height"></div>
    <div class="bottom-btn">
      <input @click="btn" type="button"  value="确认支付" class="btn"/>
    </div>
	</div>
</template>
<script>
//	import oPay from './son/paymentDetail.vue'
  	import wx from 'weixin-js-sdk';
	export default{
		data (){
			return {
        items:this.$route.params.paymentList,
        rental:this.$route.params.rental,
        wxWech:this.$route.params.wxWech,
        discount_amount:this.$route.params.discount_amount,
        payable_amount:this.$route.params.payable_amount,
        houseName:sessionStorage.getItem('el')
			}
		},
    mounted () {
		  console.log(this.$route.params)
    },
    methods:{
		  btn(){
        const _this = this
        _this.postRequest('wxSign/jsSDKSign', {
          url:window.location.href
        },function (data) {
          wx.config({
            appId: sessionStorage.getItem('appId'), // 必填，公众号的唯一标识
            timestamp: data.timestamp , // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.chooseWXPay({
            timestamp: _this.wxWech.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
            nonceStr: _this.wxWech.nonceStr, // 支付签名随机串，不长于 32 位
            package: _this.wxWech.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
            signType: _this.wxWech.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
            paySign: _this.wxWech.paySign, // 支付签名
            success: function(res) {
              // 支付成功后的回调函数
              _this.$router.go(-1)
            },
            fail:function(res){
              console.log(res);
            }
          });
        })
      }
    }
	}
</script>



<style scoped >
.clear{
  overflow: hidden;
  zoom: 1;
}
.float-l{
  float: left;
}
.float-r{
  float: right;
}
#payment{
  padding: 35px 0px;
  text-align: left;
}
#payment h4{
  /* text-align: center; */
  margin-left: 60px;
  color: red;
  font-size: 26px;
  font-weight: 400;
}
.houseName{
  line-height: 98px;
  font-size:28px;
  color:rgba(102,102,102,1);
  /*box-shadow:4px 2px 6px rgba(223,223,223,.82);*/
  padding-left: 60px;
  box-sizing: border-box;
  border-bottom:16px solid #f5f5f5;
}
.paymentDetail li{
  /*margin-top: 20px;*/
  line-height: 55px;
  padding: 15px 60px;
  box-sizing: border-box;
  font-size: 28px;
  color:rgba(153,153,153,1);
  /*box-shadow:5px 8px 5px 1px rgba(223,223,223,.82);*/
  border-bottom:1px solid #e6e6e6;
}
.paymentDetail li:last-child{
  box-shadow: none;
  border-bottom:none;
}
.paymentDetail li .span1{
  color: #F7B932;
}
.paymentDetail li .span2{
  font-size: 30px;
  color: #333333;
}
.footer-li{
  font-size:28px;
  line-height: 60px;
  padding: 15px 60px;
  box-sizing: border-box;
  color:#666;
  border-top:16px solid #f5f5f5;
}
.footer-li .p3{
  font-size: 36px;
}
.footer-li .spa4{
  color: #F7B932;

}
.footer-li .spa5{
  color: #F7B932;
  font-weight: 700;
  font-size:44px;
}
.bottom-btn{
  width: 100%;
  height: 1.6rem;
  position: fixed;
  bottom: 0;
  background: #fff;
  line-height: 1.6rem;
  left: 0;
  text-align: center;
}
/*确认支付的按钮*/
.btn{
  width: 94%;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-size:32px;
  color: #fff;
  border-radius:40px;
  background: -webkit-linear-gradient(left, #FFA650,#F7B932); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(right,  #FFA650,#F7B932); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(right, #FFA650,#F7B932); /* Firefox 3.6 - 15 */
  background: linear-gradient(to right,  #FFA650,#F7B932); /* 标准的语法 */
  /*margin-top: .5rem;*/
}
  .bottom-height{
    width: 100%;
    height: 200px;
  }
</style>




// WEBPACK FOOTER //
// src/components/pub-component/pay/payment.vue